import { ClaimFile } from '@/api/claims'
import { Typography } from '@/components'
import { ThemeColor } from '@/enums'
import { ddMMyyyy } from '@/utils'
import { Button, ColumnDef, createColumnHelper } from '@surein/ui'
import { Building2, Download, User } from 'lucide-react'
import { FileNameRow, TableCell, UnreadDot, UploaderRow } from './styles'

const columnHelper = createColumnHelper<ClaimFile>()

const createColumns = (
  t: (key: string, options?: Record<string, unknown>) => string,
  onDownload: (fileId: string) => void,
): ColumnDef<ClaimFile, unknown>[] =>
  [
    columnHelper.accessor('display_name', {
      header: () => (
        <TableCell margin="-8px 0 -8px -8px">
          {t('claimsPage.detail.files.table.name')}
        </TableCell>
      ),
      cell: ({ row }) => (
        <TableCell width="360px">
          <FileNameRow>
            {row.original.is_unread && <UnreadDot />}
            <Typography bold={row.original.is_unread} ellipsis variant="p2Body">
              {row.original.display_name}
            </Typography>
          </FileNameRow>
        </TableCell>
      ),
    }),
    columnHelper.accessor('uploaded_by_name', {
      header: () => (
        <TableCell margin="-8px 0 -8px -8px">
          {t('claimsPage.detail.files.table.uploadedBy')}
        </TableCell>
      ),
      cell: ({ row }) => {
        const isCustomer = row.original.uploaded_by_type === 'customer'
        const name =
          row.original.uploaded_by_name ||
          t('claimsPage.detail.files.sureinTeam')

        return (
          <TableCell width="220px">
            <UploaderRow>
              {isCustomer ? <User size={16} /> : <Building2 size={16} />}
              <Typography ellipsis variant="p2Body">
                {name}
              </Typography>
            </UploaderRow>
          </TableCell>
        )
      },
    }),
    columnHelper.accessor('created_at', {
      header: () => (
        <TableCell margin="-8px 0 -8px -8px">
          {t('claimsPage.detail.files.table.uploadedOn')}
        </TableCell>
      ),
      cell: ({ row }) => (
        <TableCell width="140px">
          <Typography color={ThemeColor.b50} variant="p2Body">
            {ddMMyyyy(row.original.created_at)}
          </Typography>
        </TableCell>
      ),
      size: 140,
    }),
    columnHelper.display({
      id: 'download',
      header: () => null,
      cell: ({ row }) => (
        <TableCell width="48px">
          <Button
            aria-label={t('claimsPage.detail.files.download')}
            icon={Download}
            shape="square"
            size="sm"
            variant="muted"
            onClick={() => onDownload(row.original.file_id)}
          />
        </TableCell>
      ),
      size: 48,
    }),
  ] as Array<ColumnDef<ClaimFile, unknown>>

export default createColumns
